import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@nrwl/common-lib';

@Injectable({
  providedIn: 'root'
})
export class LogsService {
  logsConfigPath = '/uicomm/getServerConfig';
  constructor(private readonly apiService: ApiService) {}

  getLogsConfig$(): Observable<any> {
    const configurl = this.logsConfigPath;
    return this.apiService.post$<any>(configurl);
  }
}
